
<div class="d-flex flex-column justify-content-center align-items-center">

  <h1 class="my-5">{{ 'HomePage.B2C_TITLE' | translate }}</h1>
  <h2 class="my-5 text-center">{{ 'HomePage.SUB_TITLE' | translate }}</h2>

  <button (click)="testNavigation('33f77159-0acd-40c4-8524-701f33aae108')" class="my-5 btn btn-primary">Buy Ticketless (Pantheon)</button>
  <button (click)="testNavigation('aa69dd34-0505-4b08-a694-c7f2fe009aee')" class="my-5 btn btn-primary">Buy Ticketless (Uffizzi)</button>
  <button (click)="testLogin()" class="my-5 btn btn-primary">LOGIN</button>
</div>
